// removed by extract-text-webpack-plugin
module.exports = {"statistickBlock":"statistic-block__statistickBlock-3ZA9-","statisticButton":"statistic-block__statisticButton-2tD0l blocks__huge-2XOet blocks__white-2DChO blocks__button-1iODk","redirect":"statistic-block__redirect-2sqnL"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/statistic-block/statistic-block.css
// module id = 766
// module chunks = 0